import { Typography } from '@mui/material';
import React from 'react';

import RecurringJobs from '../../../components/Contractors/Owner/RecurringJobs';

const RecurringJobList = () => {
    return (
        <div>
            <Typography variant='h1'>Recurring Jobs</Typography>
            <RecurringJobs />
        </div>
    );
};

export default RecurringJobList;
